// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".7fc1563b9242ba5fc0f79922948fd9e9.js";
};